export default {
    en: {
        Home: 'Home',
        TerminalName: 'Terminal name',
        AddTerminal: 'Add access terminal',
        Add: 'Add',
        AccessTerminals: 'Access terminals',
        AccessCode: 'Access code',
        ActuationType: 'Actuation type',
        ActuationTerminal: 'Actuation terminal',
        ActuationLength: 'Actuation length',
        UnconditionalExit: 'Unconditional exit',
        LastPingTime: 'Last ping time',
        Status: 'Status',
        GPIO: 'GPIO',
        Relay: 'Relay',
        ThisTerminal: 'This terminal',
        TerminalAdded: 'Access Terminal added',
        TerminalSaved: 'Access Terminal saved',
        TerminalRemoved: 'Access Terminal removed',
        Yes: 'Yes',
        No: 'No',
        Online: 'Online',
        Offline: 'Offline',
        AccessGroupAdded: 'Access group added',
        AccessGroupSaved: 'Access group saved',
        AccessGroupRemoved: 'Access group removed',
        AccessGroups: 'Access Groups',
        GroupName: 'Group name',
        GroupType: 'Group type',
        NumberOfUsers: 'Number of users',
        AllowedTerminals: 'Allowed terminals',
        NumberOfTerminals: 'Number of terminals',
        UnlimitedAccess: 'Unlimited access',
        TicketRequired: 'Ticket required',
        AddAccessGroup: 'Add Access Group',
        Save: 'Save',
        Remove: 'Remove',
        Users: 'Users',
        UserName: 'Name',
        UserEmail: 'Email',
        UserPassword: 'Password',
        UserAdmin: 'Is Admin',
        WebAccessAllowed: 'Web access allowed',
        RFIDId: 'RFID ID',
        AccessGroup: 'Access group',
        UserAdded: 'User added',
        UserRemoved: 'User removed',
        UserSaved: 'User saved',
        AddUser: 'Add user',
        ChangePassword: 'Change password',
        Logout: 'Logout',
        CurrentPassword: 'Current password',
        NewPassword: 'New password',
        RepeatNewPassword: 'Repeat new password',
        Login: 'Login',
        PleaseLogIn: 'Please log in to your account',
        LoginEmail: 'Email',
        RememberMe: 'Remember me',
        LoginPassword: 'Password',
        Accesses: 'Accesses',
        StartTime: 'Start time',
        EndTime: 'End time',
        Time: 'Time'
    },
    sl:{
        TerminalName: 'Ime konzole'
    }
}
